<div class="flex flex-col min-h-screen"  [@routeAnimation]="getRouterAnimationState()">
  <div class="flex-grow">
      <router-outlet></router-outlet>
  </div>
  <!-- Bottom Bar -->
  <vw-app-menu  [currentScreen]="currentRoute"  (screenChange)="onScreenChange($event)"></vw-app-menu>
</div>
